import api from "../services/apiService";

export const getSalesqlSettings = async () => {
  const { data } = await api.get("/salesql/settings");
  return data;
};

export const saveSalesqlToken = async (token) => {
  const { data } = await api.post("/salesql/settings", { token });
  return data;
};

export const startSalesqlSync = async () => {
  const { data } = await api.post("/salesql/sync");
  return data;
};

export const disconnectSalesqlAccount = async () => {
  const { data } = await api.post("/salesql/settings/disconnect");
  return data;
};

export const cancelSalesqlSync = async () => {
  const { data } = await api.post("/salesql/sync/cancel");
  return data;
};

export const getSalesqlSyncStatus = async (syncRunId, afterLogId = 0) => {
  const id = syncRunId || "latest";
  const { data } = await api.get(`/salesql/sync/${id}`, {
    params: { afterLogId },
  });
  return data;
};
